<template>
  <v-form class="position-relative" v-model="valid" ref="currentForm">
    <block v-if="loading"></block>

    <v-row class="ml-2 mr-2">
      <v-col cols="12" class="tabsNh">
        <template v-if="user">
          <v-col cols="12" md="12" class="d-flex justify-space-between">
            <v-btn small color="error" @click.stop="deleteDialog = true" dense>
              <v-icon> mdi-delete </v-icon>
            </v-btn>
            <v-btn small class="btn-save" @click.prevent="updateUser" dense>
              <v-icon> mdi-content-save </v-icon>
            </v-btn>
          </v-col>
        </template>
        <v-col v-else cols="12" md="12" class="d-flex justify-end">
          <v-btn small class="btn-save" @click.prevent="saveUser" dense>
            <v-icon> mdi-content-save </v-icon>
          </v-btn>
        </v-col>
      </v-col>
    </v-row>
    <v-row style="margin-top: 1.8rem; margin-bottom: 1rem" class="ml-2 mr-2">
      <v-col cols="12" md="2">
        <div class="box">
          <div style="display: flex; justify-content: center; width: 80%; margin-left: 10%">
            <v-img :src="url" class="preview-avatar"></v-img>
          </div>
          <v-file-input @change="Preview_image" v-model="userimage" ref="userimage" :rules="[maxFileSize]"
            label="Foto usuario" prepend-icon="mdi-camera" placeholder="Examinar">
          </v-file-input>
        </div>
        <div class="box">
          <div style="justify-content: center; display: flex; width: 80%; margin-left: 10%">
            <v-img :src="urlsello" class="preview-sello" />
          </div>
          <v-file-input @change="Preview_sello" v-model="sello" ref="sello" :rules="[maxFileSize]" label="Firma/sello"
            placeholder="Firma/sello" prepend-icon="mdi-camera">
          </v-file-input>
        </div>
        <div class="d-flex" style="justify-content: center">
          <v-btn class="btn-save" v-if="user" @click="ChangePasswordModal = true">
            Cambiar contraseña
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="10">
        <div class="box">
          <v-row>
            <v-col cols="12" style="margin-top: 1rem; margin-bottom: 0.5rem">
              <h3>Datos Principales</h3>
            </v-col>
          </v-row>
          <v-row v-if="$store.getters['rolesUser/isAdminOrManager']">
            <v-col cols="12" md="3">
              <v-checkbox v-model="form.status" :label="`Estado: ${form.status ? 'activo' : 'inactivo'}`"></v-checkbox>
              <!--  <v-select outlined dense  :items="['active', 'inactive']" label="Estado*" v-model="form.status" attach
                                :rules="[v => !!v || $t('required')]" required dense></v-select> -->
            </v-col>
            <!-- <v-col cols="12" md="2" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <v-checkbox v-model="form.checkedContract" label="En planilla"></v-checkbox>
            </v-col>
            <v-col cols="12" md="2" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <v-checkbox v-model="form.webAccess" label="Acceso web"></v-checkbox>
            </v-col> -->
            <v-col cols="12" md="3">
              <v-checkbox v-model="form.assignSeller" label="Asignarlo vendedor"></v-checkbox>
            </v-col>
            <v-col cols="12" md="3">
                <v-checkbox
                  v-model="form.requireCashOpening"
                  label="Obligar apertura de caja"
                ></v-checkbox>
            </v-col>
            <v-col cols="12" md="3">
                <v-checkbox
                  v-model="form.strictCashClosing"
                  class="mt-0 pt-0 mb-0 strict-cash-checkbox"
                >
                  <template v-slot:label>
                    <span class="strict-cash-label">
                      <span>Corte de caja estricto</span>
                        <v-tooltip bottom max-width="260">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      x-small
                      color="primary"
                      class="strict-cash-info-btn"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon x-small>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>No se mostraran los montos calculados por la aplicación o diferencias hasta crear el corte de caja.</span>
                </v-tooltip>
                    </span>
                  </template>
                </v-checkbox>
            </v-col>
            <v-col cols="12" md="3" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <v-checkbox v-if="businesstype == 'veterinary'" v-model="form.isDoctor" label="Disponible para asignar como Doctor"></v-checkbox>
            </v-col>
            <!-- <v-col v-else cols="12" md="4" class="d-flex justify-md-end justify-center">
              <v-btn class="btn-save btn-save-seller" @click="selectSellerDialog = true">
                <v-icon class="mr-5">mdi-card-account-details</v-icon>
                Selecionar vendedor
              </v-btn>
            </v-col> -->

          </v-row>
          <v-row>
            <v-col v-if="!user" cols="12" sm="12" md="12">
              <label>Nota: los apartados con (*) son datos requeridos</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field outlined dense v-model="form.firstName" :rules="required" label="Nombres*"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined dense v-model="form.lastName" :rules="required" label="Apellidos*"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined dense v-model="form.email" label="Correo eléctronico"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-select outlined dense :items="['Masculino', 'Femenino']" label="Sexo" v-model="form.gender"
                attach></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field outlined dense v-model="form.mobile" label="Celular"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <date-picker label="Fecha nacimiento" @dateSelected="(param) => (form.birthday = param)"
                :value="form.birthday" v-model="form.birthday"></date-picker>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined dense v-model="form.contact" label="Contacto emergencia"></v-text-field>
            </v-col>
            <v-col cols="12" md="3">
              <v-text-field outlined dense v-model="form.phoneNumber" label="Teléfono emergencia"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3">
              <v-text-field outlined dense v-model="form.dui" label="DUI*" :rules="[(v) => !!v || $t('required')]"
                required></v-text-field>
            </v-col>
            <v-col cols="12" md="2">
              <v-autocomplete outlined dense :items="countryList" attach item-text="name" v-model="form.country" required
                :rules="required" @change="onCountryChange" label="Pais*"></v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete outlined dense v-if="form.country == 'El Salvador'" attach :items="departments"
                item-text="Valores" item-value="Codigo" :rules="[(v) => !!v || $t('required')]" required
                v-model="form.department" label="Estado/Departamento*" clearable clear-icon="mdi-close"
                @change="onSalvadorDepartmentChange(form, 'country', 'department', 'municipality', 'district')"></v-autocomplete>
              <v-autocomplete outlined dense attach v-else :items="stateList" item-text="name" @change="getCities"
                v-model="form.department" label="Estado/Departamento*" :rules="[(v) => !!v || $t('required')]" required
                clearable clear-icon="mdi-close">
                <template v-slot:no-data>
                  <div class="px-4">{{ noDataLabelStates }}</div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3">
              <v-autocomplete outlined dense :items="municipalities" attach item-text="Valores" item-value="Codigo"
                v-if="form.country == 'El Salvador'" :readonly="!form.department" v-model="form.municipality"
                label="Ciudad*" :rules="[(v) => !!v || $t('required')]" required clearable clear-icon="mdi-close"
                @change="onSalvadorMunicipalityChange(form, 'country', 'municipality', 'district')"></v-autocomplete>
              <v-autocomplete outlined dense attach v-else :items="cityList" item-text="name"
                :rules="[(v) => !!v || $t('required')]" required :readonly="!form.department" v-model="form.municipality"
                label="Ciudad*" clearable clear-icon="mdi-close">
                <template v-slot:no-data>
                  <div class="px-4">{{ noDataLabelCities }}</div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col cols="12" md="3" v-if="form.country == 'El Salvador'">
              <v-autocomplete outlined dense :items="getDistrictOptions(form.country, form.department, form.municipality)" attach item-text="label" item-value="DistritoKey" :value-comparator="compareDistrictValue"
                v-model="form.district" label="Distrito" clearable clear-icon="mdi-close"
                @change="syncLocationFromDistrict(form, 'country', 'department', 'municipality', 'district')">
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row v-if="$store.getters['rolesUser/isAdminOrManager']">
            <v-col cols="12" class="mt-4" style="margin-bottom: 1rem">
              <h3>Datos de cuenta</h3>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <v-text-field outlined dense v-model="form.username" maxlength="15" :label="$t('vwuser_username')"
                :rules="[(v) => !!v || $t('required')]" required></v-text-field>
            </v-col>

            <v-col cols="12" md="3" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <span class="fixing">
                <v-autocomplete outlined dense :items="businessList" item-text="BusinessName" item-value="ID_Business"
                  attach :rules="[(v) => !!v || $t('required')]" label="Negocio del usuario*" v-model="form.userbusiness"
                  required></v-autocomplete>
              </span>
            </v-col>
            <v-col v-if="$store.getters['rolesUser/isAdminOrManager']" cols="12" md="3" class="d-flex align-end">
              <span class="fixing">
                <v-autocomplete outlined dense :items="branchesList" item-text="BranchName" item-value="ID_Branch"
                  label="Sucursal del usuario*" attach v-model="form.userbranch" required @click="fillInBranches()"
                  :rules="[(v) => !!v || $t('required')]"></v-autocomplete>
              </span>
            </v-col>
            <v-col v-if="type_user == 'ROLE_ADMIN'" cols="12" md="3" class="d-flex align-end">
              <v-autocomplete outlined dense :items="['Administrador de negocio', 'Usuario']" label="Tipo de usuario*"
                attach :rules="[(v) => !!v || $t('required')]" v-model="form.typeuser" required></v-autocomplete>
            </v-col>
            <v-col v-if="type_user == 'ROLE_ROOT'" cols="12" md="3" class="d-flex align-end">
              <span class="fixing">
                <v-autocomplete outlined dense :items="[
                  'Administrador del sistema',
                  'Administrador de negocio',
                  'Usuario',
                ]" label="Tipo de usuario" attach v-model="form.typeuser" required
                  :rules="[(v) => !!v || $t('required')]"></v-autocomplete>
              </span>
            </v-col>
            <v-col cols="12" md="3" v-if="!user">
              <span class="fixing">
                <v-text-field outlined dense type="password" v-model="form.password" :label="$t('vwuser_password')"
                  :rules="[(v) => !!v || $t('required')]" required></v-text-field>
              </span>
            </v-col>

            <v-col cols="12" md="3" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <span class="fixing">
                <v-autocomplete outlined dense :items="[
                  '1',
                  '2',
                  '3',
                  '4',
                  '5',
                  '6',
                  '7',
                  '8',
                  '9',
                  '10',
                  '11',
                  '12',
                  '13',
                  '14',
                  '15',
                  '16',
                  '17',
                  '18',
                  '19',
                  '20',
                ]" label="Punto de venta *" attach v-model="form.pointsale" required
                  :rules="[(v) => !!v || $t('required')]"></v-autocomplete>
              </span>
            </v-col>

            <v-col cols="12" md="3" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <span class="fixing">
                <v-autocomplete 
                  outlined dense 
                  :items="priceListData" 
                  item-text="id"
                  item-value="id" 
                  label="Lista de precio por defecto" 
                  attach 
                  v-model="form.pricelist">
                </v-autocomplete>
              </span>
            </v-col>
            <v-col cols="12" md="3" v-if="$store.getters['rolesUser/isAdminOrManager']">
              <v-btn
                block
                class="btn-save user-branches-btn-field"
                @click="openAllowedBranchesDialog"
              >
                Seleccionar sucursales permitidas
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </v-col>
    </v-row>

    <v-dialog v-model="allowedBranchesDialog" max-width="720">
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span>Sucursales permitidas</span>
          <v-btn icon @click="allowedBranchesDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div class="allowed-branches-panel__caption mb-8">
            Seleccione las sucursales que este usuario tendra permitidas. Para que pueda cambiar entre ellas, también debe asignarle el permiso <b>Permitir cambiar de sucursal</b>.
          </div>

          <v-alert
            v-if="!branchesList.length"
            dense
            outlined
            type="info"
          >
            No hay sucursales disponibles para el negocio seleccionado.
          </v-alert>

          <template v-else>
            <v-row class="mb-2">
              <v-col cols="12" md="8">
                <v-autocomplete
                  v-model="allowedBranchToAdd"
                  :items="availableBranchesToAdd"
                  item-text="BranchName"
                  item-value="ID_Branch"
                  outlined
                  dense
                  clearable
                  hide-details
                  label="Seleccionar sucursal"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="4" class="d-flex align-center">
                <v-btn
                  block
                  class="btn-save"
                  :disabled="!allowedBranchToAdd"
                  @click="addAllowedBranch"
                >
                  Agregar
                </v-btn>
              </v-col>
            </v-row>

            <div class="allowed-branches-table">
              <table class="allowed-branches-table__table">
                <thead>
                  <tr>
                    <th>Sucursal</th>
                    <th>Estado</th>
                    <th class="text-right">Accion</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!allowedBranchesPreview.length">
                    <td colspan="3" class="allowed-branches-table__empty">
                      No hay sucursales agregadas.
                    </td>
                  </tr>
                  <tr
                    v-for="branchItem in allowedBranchesPreview"
                    :key="branchItem.ID_Branch"
                  >
                    <td>{{ branchItem.BranchName }}</td>
                    <td>
                      <v-chip
                        x-small
                        :color="Number(branchItem.ID_Branch) === Number(form.userbranch) ? 'primary' : 'grey lighten-2'"
                        :text-color="Number(branchItem.ID_Branch) === Number(form.userbranch) ? 'white' : 'black'"
                      >
                        {{ Number(branchItem.ID_Branch) === Number(form.userbranch) ? 'Predeterminada' : 'Permitida' }}
                      </v-chip>
                    </td>
                    <td class="text-right">
                      <v-btn
                        icon
                        small
                        :disabled="Number(branchItem.ID_Branch) === Number(form.userbranch)"
                        @click="removeAllowedBranch(branchItem.ID_Branch)"
                      >
                        <v-icon small>mdi-delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </template>
        </v-card-text>
        <v-card-actions class="justify-end pa-4">
          <v-btn text @click="allowedBranchesDialog = false">Cancelar</v-btn>
          <v-btn class="btn-save" @click="applyAllowedBranchesSelection">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ChangePasswordModal" width="60%">
      <div class="white pa-4">
        <div style="
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            display: flex;
            justify-content: flex-end;
          ">
          <v-btn small class="btndelete" @click.prevent="ChangePasswordModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-row style="margin-top: 0.3rem">
          <v-col v-if="user" cols="12" md="4">
            <v-text-field outlined dense type="password" v-model="form.oldPassword"
              :label="$t('vwuser_oldpassword')"></v-text-field>
          </v-col>
          <v-col v-if="user" cols="12" md="4">
            <v-text-field outlined dense type="password" v-model="form.password"
              :label="$t('vwuser_newpassword')"></v-text-field>
          </v-col>
          <v-col v-else cols="12" md="4">
            <v-text-field outlined dense :rules="[(v) => !!v || $t('required')]" type="password" v-model="form.password"
              :label="$t('vwuser_password')"></v-text-field>
          </v-col>
          <v-col v-if="user" cols="12" md="4">
            <v-btn class="btn-save" @click="
              ChangePasswordModal = false;
            updateUser();
            ">
              Guardar
            </v-btn>
          </v-col>
        </v-row>
      </div>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="290">
      <delete-user-dialog :data="user" @close="closeDialog"></delete-user-dialog>
    </v-dialog>

    <v-dialog v-model="selectSellerDialog" max-width="70%">
      <v-card class="background-card">
        <GeneralFilter class="background border-box" :filterEndpoint="$API.sellers.getAllSellersFiltered" :search="search"
          @emptyFilter="getAllSellers" @filtered="handleFilter">
          <DxDataGrid class="isScrolledByGeneralFilter" :data-source="sellers" key-expr="ID_Seller"
            :show-row-lines="showRowLines" :show-borders="showBorders" :row-alternation-enabled="rowAlternationEnabled"
            @selection-changed="selectedSeller">
            <DxScrolling row-rendering-mode="virtual" />
            <DxSelection mode="single" />
            <DxPaging :page-size="10" />
            <DxColumn data-field="ID_Seller" caption="ID"></DxColumn>
            <DxColumn data-field="FirstName" caption="Nombres"></DxColumn>
            <DxColumn data-field="LastName" caption="Apellidos"></DxColumn>
            <DxColumn data-field="Email" caption="Correo"></DxColumn>
          </DxDataGrid>
        </GeneralFilter>
        <div class="background-card d-flex justify-end mr-10 pb-5">
          <v-btn class="btn-save" @click="selectSeller">Selecionar</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <alerts v-if="alert.show" v-on:close_alert="closeAlert" v-on:accept_alert="acceptAlert" :properties="alert">
    </alerts>
  </v-form>
</template>

<script>
import Vue from "vue";
import DatePicker from "../../../../components/DatePicker";
import Block from "../../../../components/Block";
import DeleteUserDialog from "./DeleteUserDialog";
import Alerts from "@/components/Alerts";
import { mapGetters, mapState } from "vuex";
import GeneralFilter from "../../../../components/GeneralFilter.vue";
import locationDistrictMixin from "../../../../mixins/locationDistrict";
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxPaging,
  DxSelection,
} from "devextreme-vue/data-grid";
export default {
  name: "ManageUser",
  components: {
    DeleteUserDialog,
    Block,
    DatePicker,
    Alerts,
    GeneralFilter,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
    DxSelection,
  },
  mixins: [locationDistrictMixin],
  props: ["user", "win"],
  data: () => ({
    validSeller: true,
    ChangePasswordModal: false,
    alert: {
      type: "success",
      show: false,
      header: "",
      body: "",
    },
    form: { status: true, isDoctor: false, district: "" },
    valid: false,
    tab: null,
    fieldRules: [(v) => !!v || "Campo obligatorio"],
    nameRules: [(v) => !!v || "Name is required"],
    mobileRules: [(v) => !!v || "Mobile is required"],
    userNameRules: [(v) => !!v || "User name is required"],
    emailRules: [
      (v) => !!v || "E-mail is required",
      (v) => /.+@.+/.test(v) || "E-mail must be valid",
    ],
    date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
      .toISOString()
      .substr(0, 10),
    menu: false,
    url: null,
    userimage: null,
    loading: false,
    sello: null,
    urlsello: null,
    deleteDialog: false,
    sellofname: null,
    businessList: [],
    branchesList: [],
    requiredRule: [(value) => !!value || "Required."],
    type_user: null,
    selectSellerDialog: false,
    business_user: null,
    stateList: [],
    cityList: [],
    noDataLabelStates: "Seleccione un país",
    noDataLabelCities: "No hay ciudades disponibles",
    required: [(v) => !!v || "Campo requerido"],
    sellers: null,
    showRowLines: true,
    showBorders: true,
    rowAlternationEnabled: true,
    allowedBranchesDialog: false,
    selectedAllowedBranches: [],
    allowedBranchToAdd: null,
    search: {
      filter: null,
    },
    selectedItems: null,
    validImageSize: true,
    mainRoleConfig: [
    'Administrador del sistema',
    'Administrador de negocio',
    'Usuario',
    ],
    priceListData: [],
    businesstype: null,
  }),
  async mounted() {
    
    //load the data
    this.getStates();
    this.getCities();
    await this.getAllPriceList();

    if (!this.user) {
      this.form.webAccess = true;
      this.form.requireCashOpening = false;
      this.form.strictCashClosing = false;
      this.sysParametersDefault.forEach((element) => {
        if (element.ParameterName == "country") {
          this.form.country = element.ParameterValue;
        } else if (element.ParameterName == "department") {
          this.form.department = element.ParameterValue;
        } else if (element.ParameterName == "city") {
          this.form.municipality = element.ParameterValue;
        }
      }); 
    }
   
    this.type_user = JSON.parse(localStorage.getItem("user")).roles[0];
    this.business_user = JSON.parse(localStorage.getItem("user")).business;
    this.businesstype = JSON.parse(localStorage.getItem("user")).businesstype;
    
    this.userimage = this.user ? ( this.user.ProfilePicPath ? this.user.ProfilePicPath  : null ) : null;
    this.sello = this.user?.sello ? this.user.sello : null;
    this.url = this.userimage ? this.userimage : null;
    this.urlsello = this.sello ? this.sello : null;

    if (this.user) {
      this.getAllSellers();

      this.form.typeuser = this.mainRoleConfig[ this.user.mainRole - 1 ];
      for (var el in this.user) {
        if (el == "UserName") {
          Vue.set(this.form, "username", this.user[el]);
        } else if (el == "EmergencyContact") {
          Vue.set(this.form, "contact", this.user[el]);
        } else if (el == "EmergencyContactPhone") {
          Vue.set(this.form, "phoneNumber", this.user[el]);
        } else if (el == "Status") {
          Vue.set(this.form, "status", this.user[el] === '1' ? true : false);
        } else if (el == "DateOfBirth") {
          Vue.set(this.form, "birthday", this.user[el]);
        } else if (el == "HasContract") {
          Vue.set(this.form, "checkedContract", this.user[el]);
        } else if (el == "ID_Seller") {
          Vue.set(this.form, "assignSeller", Boolean(this.user[el]));
        } else if (el == "WebAccess") {
          Vue.set(this.form, "webAccess", this.user[el]);
        } else if (el == "IsDoctor") {
          Vue.set(this.form, "isDoctor", this.user[el] === true || this.user[el] === 1 || this.user[el] === "1");
        } else if (el == "RolesGrid") {
          if (this.user[el][0]["ID_Role"] == 1) {
            Vue.set(this.form, "typeuser", "Administrador del sistema");
          } else if (this.user[el][0]["ID_Role"] == 2) {
            Vue.set(this.form, "typeuser", "Administrador de negocio");
          } else {
            Vue.set(this.form, "typeuser", "Usuario");
          }
        } else if (el == "ID_Business") {
          Vue.set(this.form, "userbusiness", parseInt(this.user[el]));
          console.log("negocio y branch ", this.user[el], this.form.userbusiness);
        } else if (el == "ID_Branch") {
          Vue.set(this.form, "originaluserbranch", parseInt(this.user[el]));
          Vue.set(this.form, "userbranch", parseInt(this.user[el]));
        } else if (el == "PointSale") {
          Vue.set(this.form, "pointsale", this.user[el] !== null && this.user[el] !== undefined ? this.user[el].toString() : null);
        } else if (el == "PriceList") {
          Vue.set(this.form, "pricelist", this.user[el] !== null && this.user[el] !== undefined ? this.user[el].toString() : null);
        } else if (el == "RequireCashOpening") {
          Vue.set(this.form, "requireCashOpening", Boolean(this.user[el]));
        } else if (el == "StrictCashClosing") {
          Vue.set(this.form, "strictCashClosing", Boolean(this.user[el]));
        } else {
          Vue.set(this.form, el[0].toLowerCase() + el.slice(1), this.user[el]);
        }

        delete this.form.password;
      }
      this.normalizeDistrictSelection(this.form, "country", "department", "municipality", "district");
    }
    await this.fillInBussiness();
    await this.fillInBranches();
    await this.loadAllowedBranches();

   
    
  },
  watch: {
    /* 'form.username': {
      deep: true,
      handler() {
        this.fillInBussiness();
      },
      inmmediate: true,
    }, */
    'form.userbusiness': {
      deep: true,
      async handler(newValue, oldValue) {
        await this.fillInBranches();
        if (newValue !== oldValue) {
          this.selectedAllowedBranches = [];
        }
      },
      inmediate: true,
    },
    'form.userbranch': {
      handler(value) {
        const branchId = Number(value);
        if (Number.isInteger(branchId) && branchId > 0 && !this.selectedAllowedBranches.includes(branchId)) {
          this.selectedAllowedBranches = [ ...this.selectedAllowedBranches, branchId ];
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getCatalogMH"]),
    ...mapState("sysparameters", {
      sysParametersDefault: (state) => state.parameters,
    }),
    departments() {
      return this.getCatalogMH("Departamento");
    },
    municipalities() {
      const municipalities = this.getCatalogMH("Municipio");
      if (this.form.department) {
        const department = municipalities.filter(
          (mun) => mun.Departamento == this.form.department
        );
        return department;
      }
      return [];
    },
    countryList() {
      return this.$store.getters.getCountries;
    },
    checkcountry() {
      if (this.form.country == "El Salvador") return true;
      else return false;
    },
    allowedBranchesPreview() {
      const selected = this.selectedAllowedBranches.map((branchId) => Number(branchId));
      return this.branchesList.filter((branchItem) => selected.includes(Number(branchItem.ID_Branch)));
    },
    allowedBranchesSummary() {
      if (!this.form.userbusiness) {
        return "Seleccione primero el negocio del usuario.";
      }

      if (!this.selectedAllowedBranches.length) {
        return "No hay sucursales adicionales seleccionadas. Se usara la sucursal principal.";
      }

      return `${this.allowedBranchesPreview.length} sucursal(es) disponible(s) para este usuario.`;
    },
    availableBranchesToAdd() {
      const selected = this.selectedAllowedBranches.map((branchId) => Number(branchId));
      return this.branchesList.filter((branchItem) => !selected.includes(Number(branchItem.ID_Branch)));
    },
  },
  methods: {
    async getAllPriceList() {
      try {
        let response = [];
        if (this.$store.getters['rolesUser/getCustomRole']('admin')){
          response = await this.$API.priceList.priceListNoData()
        }
        this.priceListData = response;
      } catch (error) {
        console.warn('getAllPriceList',error)
      }
    },
    handleFilter(response) {
      this.sellers = response;
    },
    getAllSellers() {
      this.$API.sellers.getAllSellers().then((response) => {
        console.log(response);
        this.sellers = response;
      });
    },
    getUserPayload() {
      return {
        ...this.form,
        allowedBranches: this.selectedAllowedBranches,
        isDoctor: this.form.isDoctor ? 1 : 0,
      };
    },
    async loadAllowedBranches() {
      const primaryBranch = Number(this.form.userbranch);

      if (!this.user?.ID_User) {
        this.selectedAllowedBranches = Number.isInteger(primaryBranch) && primaryBranch > 0
          ? [primaryBranch]
          : [];
        return;
      }

      try {
        const response = await this.$API.users.getAllowedBranches(this.user.ID_User);
        const allowedBranches = Array.isArray(response)
          ? response.map((item) => Number(item.ID_Branch)).filter((branchId) => Number.isInteger(branchId) && branchId > 0)
          : [];

        if (Number.isInteger(primaryBranch) && primaryBranch > 0 && !allowedBranches.includes(primaryBranch)) {
          allowedBranches.push(primaryBranch);
        }

        this.selectedAllowedBranches = [ ...new Set(allowedBranches) ];
      } catch (error) {
        if (Number.isInteger(primaryBranch) && primaryBranch > 0) {
          this.selectedAllowedBranches = [primaryBranch];
        }
      }
    },
    async getStates() {
      this.form.department = null;
      this.form.municipality = null;
      this.form.district = null;
      if (this.form.country == "El Salvador") return [];
      if (this.form.country) {
        this.noDataLabelStates = "Cargando...";
        this.stateList = [];

        this.stateList = await this.$API.general.getStates(this.form.country);
        console.log(this.stateList);
        this.noDataLabelStates = "No hay Estados disponibles";
      }
    },
    async getCities() {
      if (this.form.country == "El Salvador") return [];
      console.log(this.form.department);
      if (this.form.department) {
        this.noDataLabelCities = "Cargando...";
        this.cityList = [];

        this.cityList = await this.$API.general.getCities(this.form.department);
        console.log(this.cityList);
        this.noDataLabelCities = "No hay Ciudades disponibles";
        return this.cityList;
      }

      this.cityList = [];
      this.form.municipality = null;
      this.noDataLabelCities = "No hay Ciudades disponibles";
      return [];
    },
    async onCountryChange() {
      this.form.department = null;
      this.form.municipality = null;
      this.form.district = null;
      await this.getStates();
    },

    closeAlert() {
      this.alert.show = false;

      if (this.alert.options === "usereload") {
        this.$store.dispatch("reloadData", "users");
        // this.$store.dispatch("addWindow", {
        //   name: "UserList",
        //   component: "UserList",
        //   unique: false,
        // });
      }
    },
    acceptAlert() {
      this.alert.show = false;
    },
    showAlert(type, header, body, options = null) {
      type = type == null ? "danger" : type;
      this.alert.type = type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options != null ? options : null;
    },
    Preview_image() {
      this.url = URL.createObjectURL(this.userimage);
    },
    Preview_sello() {
      this.sellofname = this.sello.name;
      this.urlsello = URL.createObjectURL(this.sello);
    },
    async fillInBussiness() {
      const id = JSON.parse(localStorage.getItem("user")).businessid;

      if(id && this.type_user == "ROLE_ADMIN") {
        await this.$API.business.FindOne(id).then((response) => {
          if(typeof(response) == 'object') {
            this.businessList = [ response ];
          }
          else {
            this.businessList = response;
          }
        });
      }
      else if(this.business_user != "none" && this.type_user == "ROLE_ADMIN") {
        await this.$API.business.businessListFiltered({ filter: this.business_user}).then((response) => {
          this.businessList = response;
        });
      }
      else {
        await this.$API.business.businessListHistory().then((response) => {
          //this.unfilteredBusinessList = response; // Store unfiltered data
          //this.filterHandler(this.unfilteredBusinessList); // Apply filtering
          this.businessList = response;
        });
      }

      if(this.businessList.length == 1) {
        this.form.userbusiness = this.businessList[0].ID_Business;
        await this.fillInBranches();
      }
      
    },
    async fillInBranches() {
      if (!this.form.userbusiness) {
        this.branchesList = [];
        return [];
      }

      const data = await this.$API.branches.findBranches(this.form.userbusiness);
      this.branchesList = Array.isArray(data) ? data : [];
      return this.branchesList;
    },
    async openAllowedBranchesDialog() {
      if (!this.form.userbusiness) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Seleccione primero el negocio del usuario."
        );
        return;
      }

      await this.fillInBranches();

      if (!this.selectedAllowedBranches.length && this.form.userbranch) {
        this.selectedAllowedBranches = [Number(this.form.userbranch)];
      }

      this.allowedBranchToAdd = null;
      this.allowedBranchesDialog = true;
    },
    addAllowedBranch() {
      const branchId = Number(this.allowedBranchToAdd);

      if (!Number.isInteger(branchId) || branchId <= 0) {
        return;
      }

      if (!this.selectedAllowedBranches.includes(branchId)) {
        this.selectedAllowedBranches = [ ...this.selectedAllowedBranches, branchId ];
      }

      this.allowedBranchToAdd = null;
    },
    removeAllowedBranch(branchId) {
      const numericBranchId = Number(branchId);
      const primaryBranch = Number(this.form.userbranch);

      if (numericBranchId === primaryBranch) {
        return;
      }

      this.selectedAllowedBranches = this.selectedAllowedBranches.filter(
        (item) => Number(item) !== numericBranchId
      );
    },
    applyAllowedBranchesSelection() {
      const primaryBranch = Number(this.form.userbranch);

      if (Number.isInteger(primaryBranch) && primaryBranch > 0 && !this.selectedAllowedBranches.includes(primaryBranch)) {
        this.selectedAllowedBranches = [ ...this.selectedAllowedBranches, primaryBranch ];
      }

      this.allowedBranchToAdd = null;
      this.allowedBranchesDialog = false;
    },
    saveUser() {
      if (!this.$refs.currentForm.validate()) {
        console.log(`saveUser`);
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe llenar todos los campos requeridos"
        );
        return;
      }
      if (this.checkImageSize()) return;

      if (!this.valid) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe llenar todos los campos requeridos"
        );
        return;
      }
      this.loading = true;
      let formData = new FormData();
      if (this.type_user == "ROLE_ROOT") {
        this.businessList.forEach((element) => {
          if (element.ID_Business == this.form.userbusiness) {
            this.form.businesstype = element.BusinessType;
          }
        });
      } else {
        this.form.businesstype = JSON.parse(localStorage.getItem("user")).businesstype;
      }
      formData.append("user", JSON.stringify(this.getUserPayload()));
      formData.append("file", this.userimage);
      formData.append("sello", this.sello);
      /*  formData.append("sello", this.sellofname) */
      this.$API.users
        .addUser(formData)
        .then(() => {
          this.loading = false;
          this.showAlert(
            "success",
            "Usuario creado",
            "El usuario se ha creado correctamente",
            "usereload"
          );
          // this.$router.push({ name: 'UserList' })
          this.form = { status: true, isDoctor: false };
          this.form.webAccess = true;
          this.form.requireCashOpening = false;
          this.form.strictCashClosing = false;


          this.url = null;
        })
        .catch(() => {
          this.loading = false;
          this.showAlert("danger", "Error", "El usuario no se ha creado correctamente");
        });
    },
    updateUser() {
      if (this.checkImageSize()) return;

      if (!this.valid) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe llenar todos los campos requeridos"
        );
        return;
      }
      this.loading = true;
      let formData = new FormData();
      if (this.validSeller == false) {
        this.showAlert("danger", "Error", "El tamaño del archivo debe ser menor a 2 Mb");
        return;
      }
      this.form.userChangingPasswordRole = this.type_user;

      // console.log( 'USER TO SEND ' );
      // console.log( this.form )

      formData.append("user", JSON.stringify(this.getUserPayload()));
      formData.append("file", this.userimage);
      formData.append("sello", this.sello);
      for (const [key, value] of formData.entries()) {
        console.log(`${key}: ${value}`);
      }
      this.$API.users
        .updateUser(this.form.iD_User, formData)
        .then((resp) => {
          this.loading = false;
          // this.$emit('reloadData');
          this.showAlert(
            "success",
            "Usuario  Actualizado",
            "Datos de usuario agregados correctamente",
            "usereload"
          );
          // console.log(resp);
          //changue the propertie of the user
          let CurrentUser = JSON.parse(localStorage.getItem("user")).id;
          let user = this.form.iD_User;
          //resp.user.SelloLocalPath
          if (CurrentUser == user) {
            let user = JSON.parse(localStorage.getItem("user"));
            user.seal = resp.user.SelloLocalPath;
            localStorage.setItem("user", JSON.stringify(user));
          }
        })
        .catch((err) => {
          this.loading = false;
          console.log(err);
          this.showAlert(
            "danger",
            "Error",
            "El usuario no se ha podido actualizar de manera correcta"
          );
        });
    },
    closeDialog(payload) {
      this.deleteDialog = false;
      if (payload.isDeleted) {
        this.$store.dispatch("deleteWindowByUuid", { uuid: this.win.uuid });
        this.$store.dispatch("reloadData", "users");
      }
    },
    selectedSeller({ selectedRowsData }) {
      this.selectedItems = {
        ID_Seller: selectedRowsData[0].ID_Seller,
        ID_User: this.user.ID_User,
      };
      console.log(this.selectedItems);
    },
    selectSeller() {
      this.loading = true;
      this.selectSellerDialog = false;
      this.$API.users
        .updateUserSeller(this.selectedItems)
        .then(() => {
          this.loading = false;
          this.showAlert(
            "success",
            "Vendedor asignado",
            "El vendedor ha sido asignado correctamente"
          );
        })
        .catch(() => {
          this.loading = false;
          this.showAlert("danger", "Error", "El vendedor no se ha podido asignar");
        });
    },
    maxFileSize(event) {
      const allowedSize = 2 * 1024 * 1024; // 2 MB in bytes
      const fileSize = event?.size;

      if (fileSize > allowedSize) {
        this.validImageSize = false;
        return `El tamaño del archivo debe ser menor a 2 Mb`;
      }

      this.validImageSize = true;
      return true;
    },
    checkImageSize() {
      if (this.validImageSize == false) {
        this.showAlert("danger", "Error", "El tamaño de la imagen debe ser menor a 2 Mb");
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.tabs:hover {
  background-color: rgba(80, 80, 80, 1);
  cursor: pointer;
}

.tabs {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.background-card {
  background-color: white !important;
}

.btnsave {
  background-color: #00a178 !important;
  color: white;
}

.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.btn-add-seller {
  width: 80% !important;
}

.strict-cash-row {
  row-gap: 0;
}

.strict-cash-inline {
  display: inline-flex;
  align-items: center;
}

.strict-cash-label {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.strict-cash-checkbox {
  margin-right: 0;
}

.strict-cash-info-btn {
  margin-top: 0;
  margin-left: 0;
  align-self: center;
}

.user-branches-btn-field {
  height: 40px !important;
  margin-bottom: 8px;
}

.allowed-branches-panel__caption {
  color: #5c6b7a;
  font-size: 0.92rem;
}

.allowed-branches-table {
  border: 1px solid #d9e2ec;
  border-radius: 10px;
  overflow: hidden;
  background: white;
}

.allowed-branches-table__table {
  width: 100%;
  border-collapse: collapse;
}

.allowed-branches-table__table th,
.allowed-branches-table__table td {
  padding: 12px 14px;
  border-bottom: 1px solid #e6edf3;
  text-align: left;
}

.allowed-branches-table__table th {
  background: #f4f7fa;
  color: #425466;
  font-size: 0.85rem;
  font-weight: 600;
}

.allowed-branches-table__table tbody tr:last-child td {
  border-bottom: none;
}

.allowed-branches-table__empty {
  text-align: center !important;
  color: #6b7c93;
}
</style>

<style>
/*.fixing .menuable__content__active .v-list{
    max-height: 90px !important;
}*/
</style>
